import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseFormComponent } from '../../shared/base-form/base-form.component';

@Component({
  selector: 'app-account-form',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./account-form.component.scss', '../../shared/base-form/base-form.component.scss']
})
export class AccountFormComponent extends BaseFormComponent implements OnInit {

  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseRichService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.entityName = 'account';
  }

  async valueChanged(e) {
    if (e.value) {
      switch (e.element.id) {
        case 'province':
          await this.setCities(e.value);
          break;
        // case 'identification_type':
        //   let caption = '';
        //   switch (e.value) {
        //     case 'NC':
        //       caption = this.translator.instant('NATIONAL_CODE');
        //       break;
        //     case 'NI':
        //       caption = this.translator.instant('NATIONAL_ID');
        //       break;
        //     default:
        //       caption = this.translator.instant(`${e.value}_NO`);
        //       break;
        //   }
        //   this.fields.find(f => f.name === 'identification_no').caption = caption;
        //   break;
        case 'identification_no':
          if (this.token) {
            this.addUploadColumns(e.value);
          }
          break;
        default:
          await super.valueChanged(e);
          break;
      }
    }

  }

  private async setCities(province: any) {
    const cities = await this.service.apiCall('api/city/read', {
      query: ['province_name', '=', province],
      fields: ['name']
    }).toPromise();
    const city = this.formData['city'];
    this.changeDataSource('city', cities.map(c => c.name));
    setTimeout(() => {
      if (this.isEdit) {
        this.changeValue('city', city);
      } else {
        if (province === 'تهران') {
          this.changeValue('city', province);
        }
      }
    }, 500);
  }

  addUploadColumns(id: any) {
    this.uploadPath = `account/${id}`;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    setTimeout(async () => {
      if (!this.isEdit) {
        this.changeValue('nationality', 'IRN');
      } else {
        await this.setCities(this.formData['province']);
      }
      if (this.formData['identification_no']) {
        this.addUploadColumns(this.formData['identification_no']);
      }
    }, 100);
  }

}
